import { Component, Input } from '@angular/core';
import { Steps } from '../landing-page.modal';


@Component({
  selector: 'home-ui',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  imports: [],
  standalone: true,
})
export class HomeComponent {
  @Input()
  steps!: Steps[];
}
